angular.module('assets')
    .component('projectAcceptance', {
        bindings: {
            user: '<?',
            time: '<?'
        },
        template: `
            <div class="form-group input-group-sm" style="margin-top: 10px;" ng-if="$ctrl.user">
                <label>{{'asset-doc.header.accepted-by' | translate}}</label>
            </div>
            <div class="form-group">
                <user-avatar user="$ctrl.user"></user-avatar>&nbsp;{{$ctrl.user.fullName}}
            </div>
            <div class="form-group" style="margin-bottom: 10px;">
                <span class="help-block">{{$ctrl.time | date : 'd MMM y H:mm:ss'}}</span>
            </div>
        `
    })
